import React from 'react';
import { ArrowRightIcon, CheckIcon, GlobeIcon, LockIcon, ShieldIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { checkoutUrl, ctaLabelSystem, packageContents, trackCheckout } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-graphite" data-id="element-200" data-mp="1ja9yt9qyh8jl">
      <div className="max-w-3xl mx-auto" data-id="element-201" data-mp="1n9ipg5qp8qax">
        <div className="text-center mb-10" data-id="element-202" data-mp="1ncmzvkurcia1">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase mb-3 text-white" data-id="element-203" data-mp="1s8u9poq9ydx9">
            Your complete <span className="text-orange" data-id="element-204" data-mp="1x9rpxvrq4xw4">6-in-1 offer</span>{' '}
            today
          </h2>
          <p className="text-white/70 text-sm md:text-base" data-id="element-205" data-mp="226rws8wee4oa">
            Everything you need to coach hybrid fitness racing with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-charcoal border-2 border-orange rounded-3xl p-1 relative shadow-[0_24px_60px_-40px_rgba(0,0,0,0.9)]" data-id="element-206" data-mp="7tih1zd9dmxl">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-orange text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-207" data-mp="1cr4trzqhv5mu">
            <SparklesIcon size={14} aria-hidden="true" data-id="element-208" data-mp="25dg2xys62ev9" /> Complete package
          </div>
          <div className="bg-charcoal rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-209" data-mp="20h90wh2w5nil">
            <h3 className="text-2xl md:text-3xl font-display font-bold uppercase text-white mb-3" data-id="element-210" data-mp="1vfrxoewxpoyu">
              Hybrid Race Coach Ready — Complete 6-in-1 Coaching System
            </h3>
            <p className="text-base text-white/70 mb-6" data-id="element-211" data-mp="k2z91czfxgn0">
              120 ready-to-coach sessions, 6 volumes and 5 premium bonuses.
            </p>

            <ul className="text-left space-y-2.5 mb-8 bg-graphite border border-white/10 rounded-xl p-5" data-id="element-212" data-mp="hhruf1xq35p9">
              {packageContents.map(item => <li key={item} className="flex items-start gap-3" data-id="element-213" data-mp="mfjhninfa3n4">
                  <CheckIcon size={16} className="text-orange shrink-0 mt-0.5" aria-hidden="true" data-id="element-214" data-mp="7k3n7cixk5q7" />
                  <span className="text-white/85 text-sm" data-id="element-215" data-mp="3uwo5u8ebl70k">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-216" data-mp="3i8moa8tpwdh">
              <span className="text-lg text-white/50 line-through block mb-1" data-id="element-217" data-mp="3jjssgpqrg7r">
                $105.00 USD
              </span>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-218" data-mp="3kwni8a9f44qk">
                <span className="text-2xl md:text-3xl text-white/70" data-id="element-219" data-mp="3pvgxo889m5td">
                  TODAY:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-white" data-id="element-220" data-mp="3fzdvx3hbs96y">
                  $27.00 <span className="text-orange" data-id="element-221" data-mp="3g1hv584a4k0w">USD</span>
                </span>
              </div>
            </div>

            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-222" data-mp="2sc09fhfpclbj">
              {ctaLabelSystem}
              <ArrowRightIcon size={18} aria-hidden="true" data-id="element-223" data-mp="31bx4c0soqgf1" />
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60 mb-4" data-id="element-224" data-mp="3g960d7sxo8d3">
              <span className="flex items-center gap-1.5" data-id="element-225" data-mp="3b9tcqku8mx9g">
                <LockIcon size={12} className="text-orange" aria-hidden="true" data-id="element-226" data-mp="3p29gxoyvl1by" />{' '}
                Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-227" data-mp="3l1qnjqhc3n7n">
                <ZapIcon size={12} className="text-orange" aria-hidden="true" data-id="element-228" data-mp="2v2lk9hkzg67" />{' '}
                Instant access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-229" data-mp="3u2f34pmdlvmn">
                <ShieldIcon size={12} className="text-orange" aria-hidden="true" data-id="element-230" data-mp="hy2mz25qs71u" />{' '}
                7-day guarantee
              </span>
            </div>

            <div className="bg-graphite border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-231" data-mp="qq4jipcox36u">
              <GlobeIcon className="text-orange shrink-0 mt-0.5" size={14} aria-hidden="true" data-id="element-232" data-mp="voze0ok0sg6s" />
              <p className="text-[11px] text-white/60 leading-snug" data-id="element-233" data-mp="30a9sgno3uqt">
                Pay in your local currency. The amount adjusts automatically
                based on the country you are purchasing from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}